/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import { useUserStore, useDashboardStore } from '../../../store/models';

function useAnalyticsConnectExplore() {
    const userStore = useUserStore();
    const dashboardStore = useDashboardStore();
    const [isLoading, setIsLoading] = useState(false);
    const [integrationApps, setIntegrationApps] = useState(null);

    useEffect(() => {
        if (userStore.publisher) {
            console.log('updateIntegrationApps() -> ');
            dashboardStore.updateIntegrationApps();
        }
    }, [userStore.observed.publisher]);

    useEffect(() => {
        if (dashboardStore.integrationApps) {
            setIntegrationApps(dashboardStore.integrationApps);
        }
    }, [dashboardStore.observed.integrationApps]);

    function searchApp(searchText) {
        dashboardStore.searchApp(searchText);
    }

    return {
        isLoading,
        setIsLoading,
        integrationApps,
        searchApp,
    };
}

export default useAnalyticsConnectExplore;
